import React from "react";
import moment from "moment-timezone";

export function describeCalendarEvent(event, timeZone) {
  const kind = event.extendedProps?.kind || "availability";
  const status = event.extendedProps?.source?.status;
  const label = kind === "availability" ? "Working hours" : kind === "block" ? "Blocked time" : kind === "hold" ? "Reserved" :
    ({ proposed: "Pending", fulfilled: "Completed", cancelled: "Cancelled", no_show: "No show" }[status] || "Appointment");
  let title = event.title;
  const reason = event.extendedProps?.source?.reasonCode;
  if (kind === "block" && reason) title = title.replace(reason, reason.charAt(0) + reason.slice(1).toLowerCase().replaceAll("_", " "));
  const start = moment(event.start).tz(timeZone);
  const end = event.end ? moment(event.end).tz(timeZone) : null;
  const time = start.format("h:mm A");
  const range = end ? `${time}–${end.format("h:mm A")}${end.isSame(start, "day") ? "" : ` (${end.format("MMM D")})`}` : time;
  return { label, title, time, range, description: `${label} · ${title} · ${range}` };
}

export default function CalendarEventContent({ event, timeZone, viewType }) {
  const { label, title, time, range, description } = describeCalendarEvent(event, timeZone);
  const compact = viewType === "dayGridMonth" || moment(event.end).diff(moment(event.start), "minutes") < 60;
  return <div className={`schedule-event-card${compact ? " is-compact" : ""}`} title={description}>
    {compact ? <><span className="schedule-event-clock">{time}</span><strong>{title}</strong></> :
      <>{label !== "Appointment" && <span className="schedule-event-kind">{label}</span>}<strong>{title}</strong><span className="schedule-event-clock">{range}</span></>}
  </div>;
}
